import HttpRequest from "../Http/HttpRequest";

let SITE_CONFIG = null;
export default class SiteConfig {

    async getSiteConfig() {
        if (SITE_CONFIG) {
            return SITE_CONFIG;
        }
        SITE_CONFIG = await HttpRequest.get('node/site/bff-home');
        return SITE_CONFIG;
    }


}
